export const formatPrice = (value: number) => {
  const valorReais = (value ?? 0) / 100;
  if (!valorReais || valorReais === 0) return "0,00";
  return valorReais.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};
